import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LoginPopupComponent } from '../../admin-container/login-popup/login-popup.component';

@Component({
  selector: 'app-home-list',
  templateUrl: './home-list.component.html',
  styleUrls: ['./home-list.component.scss'],
})
export class HomeListComponent implements OnInit {

  constructor(public g: Globals, private ngbModal: NgbModal, public activeModal: NgbActiveModal) {
    if (this.g.profilePopupDisplay == 0) {
      if (!this.g.profilePopup.isMOUDocPresent || !this.g.profilePopup.isDefaultWHPresent || !this.g.profilePopup.isKYCVerified || !this.g.profilePopup.isDefaultAddressPresent || !this.g.profilePopup.isChannelPresent) {
        this.openPopup();
      }
    }
  }
  openPopup() {
    const modalRef = this.ngbModal.open(LoginPopupComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'model-width', backdrop: "static", keyboard: false });
    modalRef.result.then((response) => {
    }, (reason) => {
    });
  }


  ngOnInit() { }

}
